var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.saveStatus
        ? _c("SuccessfulResponse", {
            attrs: { type: _vm.type, attestationCheck: _vm.attestationCheck },
            on: {
              close: function ($event) {
                return _vm.$emit("close")
              },
            },
          })
        : _vm.errorLoadingParameters
        ? _c("ErrorResponse", {
            attrs: { errorLoadingParameters: _vm.errorLoadingParameters },
            on: {
              close: function ($event) {
                return _vm.$emit("close")
              },
              retry: function ($event) {
                return _vm.$emit("retry")
              },
            },
          })
        : _vm.hasDuplicateName
        ? _c("DuplicateResponse", {
            attrs: { type: _vm.type },
            on: {
              close: function ($event) {
                return _vm.$emit("close")
              },
              "change-name": function ($event) {
                return _vm.$emit("change-name")
              },
            },
          })
        : _c("FailureResponse", {
            on: {
              close: function ($event) {
                return _vm.$emit("close")
              },
              save: function ($event) {
                return _vm.$emit("save")
              },
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }